import React, { useState } from "react";
import { Button, Checkbox, Segment } from "semantic-ui-react";
import { BasicModal } from "../../../components/Shared";
import {
  ListPaymentCategory,
  PaymentCategoryForm,
} from "../../../components/Admin/PaymentCategory";
import "./PaymentCategory.scss";

export function PaymentCategory() {
  const [showModal, setShowModal] = useState(false);
  const [reload, setReload] = useState(false);
  const [showActive, setShowActive] = useState(true);

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onReload = () => setReload((prevState) => !prevState);

  return (
    <>
      <div className="payment_category-page">
        <div className="payment_category-page__header">
          <div className="payment_category-page__filters">
            <div className="payment_category-page__switch-container">
              <span className={`switch-label inactive ${!showActive ? 'active' : ''}`}>Mostrar inactivas</span>
              <Checkbox
                toggle
                checked={showActive}
                onChange={() => setShowActive(!showActive)}
              />
              <span className={`switch-label success ${showActive ? 'active' : ''}`}>Mostrar activas</span>
            </div>
          </div>
          <Button
            className="payment_category-page__add"
            primary
            onClick={onOpenCloseModal}
          >
            Nueva categoría de pago
          </Button>
        </div>
        <Segment className="payment_category-page__list">
          <ListPaymentCategory
            status={showActive ? "true" : "false"}
            reload={reload}
            onReload={onReload}
          />
        </Segment>
      </div>
      <BasicModal
        show={showModal}
        close={onOpenCloseModal}
        title="Crear categoría de pago"
      >
        <PaymentCategoryForm onClose={onOpenCloseModal} onReload={onReload} />
      </BasicModal>
    </>
  );
}
